module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"nodata":"这里什么都没有哦,","toStore":"快去<span class=\u0027tostore\u0027>模板社区</span>看看吧"},"en":{"nodata":"It is empty"},"kr":{"nodata":"아직 아무 작업도 없네요~","toStore":"<span class=\u0027tostore\u0027 > 템플릿 커뮤니티 </span>에 가보세요"},"tw":{"nodata":"這裡什麼都沒有哦"},"jp":{"nodata":"空です"},"id":{"nodata":"Kosong"}}')
  delete Component.options._Ctor
}
